import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Loader } from "../index";
function LoadingContent(props) {
    const { text } = props;
    return (_jsxs("div", { className: "fixed-full-page", children: [_jsx("div", { className: "fixed-centered-loader", children: _jsx(Loader, {}) }), _jsx("div", { className: "fixed-centered-text", children: text || "Loading..." })] }));
}
export default LoadingContent;
